var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"ending"},[_c('img',{directives:[{name:"scroll-animate",rawName:"v-scroll-animate",value:('animate__fadeIn'),expression:"'animate__fadeIn'"}],attrs:{"src":require("@/assets/images/u36.png"),"alt":"Ending Image"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }